module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "test_call"
  }, [_c('div', {
    staticClass: "modal-card"
  }, [_c('header', {
    staticClass: "modal-card-head"
  }, [_c('div', {
    staticClass: "modal-card-title"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('testCall.testCall')))])])]), _vm._v(" "), _c('button', {
    staticClass: "delete",
    attrs: {
      "aria-label": "close",
      "title": _vm.$t('common.actions.close')
    },
    on: {
      "click": function($event) {
        return _vm.closeTestCall()
      }
    }
  })]), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body",
    class: _vm.testPhoneParametersArray.length > 3 ? 'scrolled' : ''
  }, [_c('div', {
    staticClass: "control is-grouped"
  }, [_c('p', {
    staticClass: "control is-expanded"
  }, [_c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticClass: "webRtcDialplanCondition",
    attrs: {
      "v-model": _vm.webRtcDialplanCondition,
      "placeholder": "webRtcDialplanCondition"
    }
  }), _vm._v(" "), _c('vb-switch-with-two-labels', {
    attrs: {
      "model": _vm.callToPhone,
      "label-left": _vm.$t('testCall.calInBrowser'),
      "label-right": _vm.$t('testCall.callToPhone'),
      "onchange": _vm.callToPhoneOnChangeEvent
    },
    on: {
      "update:model": function($event) {
        _vm.callToPhone = $event
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!!_vm.callToPhone && _vm.tmp.campaignList.length),
      expression: "!!callToPhone && tmp.campaignList.length"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.testPhone),
      expression: "testPhone"
    }],
    staticClass: "input phone",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('callTasks.phoneNumber')
    },
    domProps: {
      "value": (_vm.testPhone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.testPhone = $event.target.value
      }
    }
  })], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!!_vm.callToPhone && _vm.tmp.campaignList.length),
      expression: "!!callToPhone && tmp.campaignList.length"
    }],
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tmp.campaignId),
      expression: "tmp.campaignId"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tmp, "campaignId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.tmp.campaignList), function(campaign) {
    return _c('option', {
      domProps: {
        "value": campaign.id
      }
    }, [_vm._v(_vm._s(campaign.name))])
  }), 0)]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "is-small note"
  }, [(_vm.callToPhone) ? _c('div', [_vm._v(_vm._s(_vm.$t('testCall.toPhoneNote')))]) : _c('div', [_vm._v(_vm._s(_vm.$t('testCall.inBrowserNote')))])]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table is-bordered is-striped is-narrow"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('common.key')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('common.value')))]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.testPhoneParametersArray), function(param, index) {
    return _c('tr', [_c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (param[0]),
        expression: "param[0]"
      }],
      staticClass: "input",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (param[0])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(param, 0, $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (param[1]),
        expression: "param[1]"
      }],
      staticClass: "input",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (param[1])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(param, 1, $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "button is-light",
      staticStyle: {
        "width": "100%"
      },
      on: {
        "click": function($event) {
          return _vm.deleteTestPhoneParameter(index)
        }
      }
    }, [_vm._m(0, true), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('common.actions.delete')))])])])])
  }), _vm._v(" "), _c('tr', [_c('td', [_c('button', {
    staticClass: "button is-light addParam",
    staticStyle: {
      "width": "100%"
    },
    on: {
      "click": _vm.addTestPhoneParameter
    }
  }, [_vm._m(1), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('common.actions.add')))])])]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td')])], 2)])])])]), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot"
  }, [_c('button', {
    staticClass: "button is-primary",
    attrs: {
      "disabled": (_vm.callToPhone && !_vm.testPhone) || (!_vm.callToPhone && !_vm.webRtcDialplanCondition) || _vm.creatingTestCall
    },
    on: {
      "click": function($event) {
        return _vm.callTest()
      }
    }
  }, [(_vm.callToPhone) ? _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fas fa-phone-volume"
  })]) : _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fas fa-headset"
  })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('testCall.call')))])]), _vm._v(" "), _c('button', {
    staticClass: "button",
    attrs: {
      "title": _vm.$t('common.actions.close')
    },
    on: {
      "click": function($event) {
        return _vm.closeTestCall()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.actions.cancel')))])]), _vm._v(" "), (_vm.debuggingDialog) ? _c('DebugDialog', {
    attrs: {
      "on-finish": _vm.onDialogFinish,
      "on-new-message": _vm.onDialogNewMessage,
      "web-socket-session-id": _vm.webSocketSessionId
    },
    on: {
      "update:webSocketSessionId": function($event) {
        _vm.webSocketSessionId = $event
      },
      "update:web-socket-session-id": function($event) {
        _vm.webSocketSessionId = $event
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('audio', {
    staticClass: "remoteAudio"
  }), _vm._v(" "), _c('audio', {
    staticClass: "localAudio"
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-minus-circle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-plus-circle"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28a5cb3f"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/scenarios/konstruktor/TestCall.vue
// module id = 543
// module chunks = 42